import dayjs from 'dayjs';

export const defaultDateRange = {
  startDate: dayjs().subtract(7, 'day').valueOf(),
  endDate: dayjs().valueOf()
};
